// extracted by mini-css-extract-plugin
export var root = "Chip-module--root--b4116";